import * as React from 'react';
import * as Modal from 'react-modal';

import { isArrayWithItems } from '../../../utils';
import { ILegendItem } from '../../../utils/legend';
import * as styles from './index.css';

export interface ILegendModalProps {
  isOpen: boolean;
  legendData: ILegendItem[];

  close(): void;
}

export class LegendModal extends React.PureComponent<ILegendModalProps, {}> {
  public render() {
    const { legendData } = this.props;

    if (!isArrayWithItems(legendData)) {
      return null;
    }

    return (
      <Modal
        isOpen={this.props.isOpen}
        ariaHideApp={false}
        onRequestClose={this.close}
        style={{
          content: {
            overflow: 'visible',
            padding: '0',
            position: 'static',
            width: '240px',
            zIndex: 101,
          },
          overlay: {
            alignItems: 'center',
            backgroundColor: 'rgba(24, 41, 48, .8)',
            display: 'flex',
            justifyContent: 'center',
            zIndex: 100,
          },
        }}
      >
        <ul className={styles['list']}>
          {legendData.map(item => (
            <li
              key={item.color}
              className={styles['item']}
              style={{
                borderColor: item.color,
              }}
            >
              {item.title}
            </li>
          ))}
        </ul>
        <button className={styles['close']} onClick={this.close}>
          Закрыть
        </button>
      </Modal>
    );
  }

  private close = () => {
    this.props.close();
  };
}
